{
  "$schema": "./schema.json",
  "agents": {
    "reasonExplanation": {
      "title": "Förslag på förklaring",
      "originalText": "Originaltext",
      "enhancedText": "Föreslagen version",
      "generatingEnhancedTitle": "Tar fram förslag…",
      "generatingEnhancedDescription": "Går igenom din text och tar fram en tydligare version",
      "acceptEnhanced": "Använd föreslagen version",
      "requestFurtherEnhancement": "Skapa ett nytt förslag",
      "cancel": "Avbryt",
      "button": "Spara",
      "regeneratePlaceholder": "Valfritt: Lägg till mer information eller vägledning för ett bättre förslag…",
      "regenerateButton": "Skapa nytt förslag med input",
      "aiAssist": "AI-support",
      "tooltip": "Få hjälp att skriva en tydlig och strukturerad förklaring"
    }
  }
}
